import redDeleteIcon from "../../assets/icons/red-delete-icon.svg";
import shareIcon from "../../assets/icons/share-icon.svg";
import { VALID_MERGE_FIELD_KEYS } from "../../constants/textEditor";

export const emailTemplateTableHeaders = (templateType: string) => {
  return [
    { key: "templateName", label: "Template Name", isSortable: false },
    { key: "folder", label: "Folder", isSortable: false },
    {
      key: `${templateType === "Email" ? "emailSubjectLine" : "description"}`,
      label: `${templateType === "Email" ? "Email Subject Line" : "Description"}`,
      isSortable: false,
    },
    { key: "lastEdited", label: "Last Edited", isSortable: false },
    { key: "action", label: "Action", isSortable: false },
  ];
};

export const actionOptions = (permissions: any, templateType: string, isEmailConfigured: boolean) => {
  return [
    templateType === "Email" && {
      label: "Share",
      value: "Share",
      disabled: !permissions.canWrite,
      id: 1,
      src: shareIcon,
      tooltipText: "",
    },
    {
      label: "Archive",
      value: "Archive",
      disabled: !permissions.canDelete,
      id: 3,
      src: redDeleteIcon,
      tooltipText: "",
    },
  ].filter(Boolean);
};

export const formattedFolderNameFilterOptions = (folderOptions: any[]) => {
  return folderOptions.map((folder) => ({
    id: folder.id,
    value: folder.folder_name,
  }));
};

export const templateStyleOptions = [
  { id: 1, value: "HTML" },
  { id: 2, value: "Plain Text" },
];

export const unsubscribeUserFilterOptions = [
  {
    labels: "Opt Out Date",
    value: false,
  },
  {
    labels: "User Type",
    value: false,
  },
];

export const validateMergeTokens = (htmlString: string) => {
    const invalidTokens: string[] = [];
    const validKeys = VALID_MERGE_FIELD_KEYS;

    // ✅ Fully formed tokens
    const fullTokenRegex = /%%([A-Za-z0-9.]+)%%/g;
    let match;
    while ((match = fullTokenRegex.exec(htmlString)) !== null) {
      const tokenContent = match[1];
      if (!validKeys.has(tokenContent)) {
        invalidTokens.push(`%%${tokenContent}%%`);
      }
    }

    // ✅ Broken or incomplete tokens
    // Match patterns starting with % and containing only allowed token chars
    const brokenTokenRegex = /%{1,2}[A-Za-z0-9.]+%{0,2}/g;
    const brokenMatches = htmlString.match(brokenTokenRegex) || [];
    brokenMatches.forEach(token => {
      const stripped = token.replace(/^%%|%%$/g, ""); // remove wrapping
      const isValidFull = /^%%[A-Za-z0-9.]+%%$/.test(token) && validKeys.has(stripped);
      if (!isValidFull) {
        invalidTokens.push(token);
      }
    });

    if (invalidTokens.length > 0) {
      console.log('Invalid tokens found:', invalidTokens);
      return false;
    }

    return true;
  };